import { render, staticRenderFns } from "./chat-user-control.vue?vue&type=template&id=2fe1a8ac&"
import script from "./chat-user-control.vue?vue&type=script&lang=js&"
export * from "./chat-user-control.vue?vue&type=script&lang=js&"
import style0 from "./chat-user-control.vue?vue&type=style&index=0&id=2fe1a8ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports